// Corrected EditAuthentication
// Added submit button inside the form
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// =========================================
// CSS IMPORT (alag file)
// =========================================
import "./editauthentication.css";

const EditAuthentication = ({ authentication = {}, onChange, onSubmit }) => {
  if (!authentication) {
    return <div className="text-center mt-5">Authentication data is missing...</div>;
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedAuthData = {
      ...authentication,
      [name]: type === "checkbox" ? checked : value,
    };

    if (name === "noEmail") {
      if (checked) {
        const username = sessionStorage.getItem("username") || "";
        updatedAuthData.userName = username;
        updatedAuthData.confirmUserName = username;
      } else {
        const email = authentication.id
          ? localStorage.getItem("userEmail") || ""
          : "";

        updatedAuthData.userName = email;
        updatedAuthData.confirmUserName = email;
      }
    }

    onChange(updatedAuthData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await onSubmit(authentication);

    if (success) {
      onChange({
        ...authentication,
        password: "",
        confirmPassword: "",
      });
    }
  };

  const {
    noEmail = false,
    currentPasswordMask = "********",
  } = authentication;

  return (
    <div className="authentication-wrapper">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div className="row">
        <div className="col-md-10">

          <h1 className="authentication-title">
            Authentication
          </h1>

          <div className="authentication-form-container">
            <form onSubmit={handleSubmit}>

              {/* ID */}
              <div className="authentication-form-group">
                <label>ID:</label>

                <input
                  type="text"
                  name="id"
                  value={authentication.id || ""}
                  onChange={handleInputChange}
                  disabled={true}
                />
              </div>

              {/* No Email */}
              <div className="authentication-form-group">
                <label>No email?</label>

                <input
                  type="checkbox"
                  name="noEmail"
                  checked={noEmail}
                  onChange={handleInputChange}
                />
              </div>

              {/* Username / Email */}
              <div className="authentication-form-group">
                <label>
                  {noEmail ? "Username" : "Email"}:
                </label>

                <input
                  type="text"
                  name="userName"
                  value={authentication.userName || ""}
                  onChange={handleInputChange}
                  disabled={false}
                />
              </div>

              {/* Confirm Username / Email */}
              <div className="authentication-form-group">
                <label>
                  Confirm {noEmail ? "Username" : "Email"}:
                </label>

                <input
                  type="text"
                  name="confirmUserName"
                  value={authentication.confirmUserName || ""}
                  onChange={handleInputChange}
                  disabled={false}
                />
              </div>

              {/* Current Password */}
              <div className="authentication-form-group">
                <label>Current Password:</label>

                <input
                  type="text"
                  name="currentPasswordMask"
                  value={currentPasswordMask}
                  disabled={true}
                />
              </div>

              {/* New Password */}
              <div className="authentication-form-group">
                <label>New Password:</label>

                <input
                  type="password"
                  name="password"
                  value={authentication.password || ""}
                  onChange={handleInputChange}
                  placeholder="Enter new password"
                />
              </div>

              {/* Confirm Password */}
              <div className="authentication-form-group">
                <label>Confirm Password:</label>

                <input
                  type="password"
                  name="confirmPassword"
                  value={authentication.confirmPassword || ""}
                  onChange={handleInputChange}
                  placeholder="Confirm new password"
                />
              </div>

              {/* Save Button */}
              <div className="authentication-form-group">
                <button
                  type="submit"
                  className="authentication-submit-button"
                >
                  Save Authentication
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAuthentication;